<template>
  <v-sheet class="mx-auto" max-width="2000">
    <v-card-text>
      <v-card class="mx-auto" elevation="0" title="Project overview">
        <v-row no-gutters>
          <v-col cols="3"></v-col>
          <v-col cols="6">
            <div v-html="projectDescription"></div>
          </v-col>
          <v-col cols="3"></v-col>
        </v-row>
      </v-card>
    </v-card-text>
  </v-sheet>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'InternalOrderCancerProjectOverview',
  props: {
    icd: String,
    diseaseDescription: String,
    projectDescription: String,
    visible: Boolean
  },
});
</script>
